import { HighlightConfigGroupLike } from '../components/main-map/components/highlight-config-form/highlight-config-form.component';

const defaultColor = '#d2691e'

export const defaultHighlightConfig: HighlightConfigGroupLike = {
  point: {
    size: 24,
    fillColor: defaultColor,
  },
  line: {
    outlineWidth: 8,
    outlineColor: defaultColor,
  },
  polygon: {
    outlineWidth: 2,
    outlineColor: defaultColor,
    fillColor: '#deb887',
  },
  opacity: 0.7,
};
